module.exports = __webpack_public_path__ + "static/4-1046e279ff9e8c1e4c45fdfafb8f5138.jpg";